import React from "react";
import Hero from "../../components/medical/Hero";
import ClientWorks from "../../components/ClientWorks";
import HighlightedContactSection from "../../components/HighlightedContactSection";

export default function CaseStudiesPage() {
  return (
    <>
      <Hero title="Fallstudien" subheading="Konkrete Projekte und Lösungen aus unserer Beratungspraxis." />
      <div className="min-h-screen bg-white">
        <ClientWorks />
        <HighlightedContactSection
          heading="Haben Sie eine ähnliche Herausforderung?"
          description="Nehmen Sie Kontakt mit uns auf – wir besprechen gerne Ihr Anliegen."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-fallstudien-contact"
        />
      </div>
    </>
  );
}
